import { JurisdictionOverrideModel } from "./../models/jurisdiction-override-model";
import { FacetModel } from "./../models/facet";
import Marionette from "../../shared/marionette-mustache";
import { backboneViewProperties } from "../../decorators/backbone-properties";

const template = require<string>("../../search/views/jurisdiction-filter.html");

@backboneViewProperties({
    tagName: "li",
    template: template,
    className: "js-jurisdiction-override-option"
})
export class JurisdictionFilterView extends Marionette.ItemView<JurisdictionOverrideModel> {
    public model: JurisdictionOverrideModel;
    constructor(options) {
        super(options);
        this.listenTo(this.model, "change:Ticked", this.tickedChanged);
    }

    public onShow() {
        this.tickedChanged();
    }

    public tickedChanged() {
        this.$(`input`).prop("checked", this.model.Ticked);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click input"] = (e) => this.checkboxClicked(e);
        return events;
    }

    public checkboxClicked(e: JQueryMouseEventObject) {

        this.model.Ticked = !this.model.Ticked;

        this.model.searchModel.filterChangedReRunSearch();

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/jurisdiction-filter.ts